import { api } from './client';
import type { NavMenuNode } from './platform-nav-menu';

export interface TenantPermissionDef {
  id: string;
  code: string;
  resourceKind: 'API' | 'MENU' | 'BUTTON';
  name: string | null;
  description: string | null;
}

export interface TenantRoleRow {
  id: string;
  name: string;
  description: string | null;
  permissions: Array<{ permission: TenantPermissionDef }>;
  menuItems?: Array<{ menuKey: string }>;
  _count: { users: number };
}

export interface TenantMenuCatalogResponse {
  items: Array<{
    path: string;
    label: string;
    group?: string;
    permissions: string[];
    notes?: string;
  }>;
}

export const tenantRbacApi = {
  listPermissions: () =>
    api.get<TenantPermissionDef[]>('/api/tenant/rbac/permissions'),

  listRoles: () => api.get<TenantRoleRow[]>('/api/tenant/rbac/roles'),

  getMenuCatalog: () =>
    api.get<TenantMenuCatalogResponse>('/api/tenant/rbac/menu-catalog'),

  getMenuTree: () =>
    api.get<NavMenuNode[]>('/api/tenant/rbac/menu-tree').then((r) => r.data),

  getRoleMenu: (roleId: string) =>
    api.get<{ menuKeys: string[] }>(`/api/tenant/rbac/roles/${roleId}/menu`),

  setRoleMenu: (roleId: string, menuKeys: string[]) =>
    api.put<TenantRoleRow>(`/api/tenant/rbac/roles/${roleId}/menu`, {
      menuKeys,
    }),

  createRole: (body: {
    name: string;
    description?: string;
    permissionCodes?: string[];
    featurePermissionKeys?: string[];
  }) => api.post<TenantRoleRow>('/api/tenant/rbac/roles', body),

  updateRole: (
    id: string,
    body: {
      name?: string;
      description?: string;
      permissionCodes?: string[];
      featurePermissionKeys?: string[];
    },
  ) => api.patch<TenantRoleRow>(`/api/tenant/rbac/roles/${id}`, body),

  deleteRole: (id: string) =>
    api.delete<{ success: boolean }>(`/api/tenant/rbac/roles/${id}`),
};
